import React from 'react';
import SurveyPage from '../components/SurveyPage';
import SurveyTitleArea from '../components/SurveyTitleArea';
import SurveySection from '../components/SurveySection';
import SurveyElement from '../components/SurveyElement';
import SurveyContentContainer from '../components/SurveyContentContainer';
import SurveyGridHeader from '../components/GridComponents/SurveyGridHeader';
import SurveyGridBody from '../components/GridComponents/SurveyGridBody';
import SurveyGridRow from '../components/GridComponents/SurveyGridRow';
import {  ElementType, NumberFormat, PlaceholderFormat,} from '../Enums/constants';
import {getCurrencyPlaceHolder} from "../helpers";


export const PabsMembersTab = () => {
  let currencyPlaceHolder = getCurrencyPlaceHolder(PlaceholderFormat.CURRENCY_SINGULAR);
  
  return (
    <SurveyPage>
      <SurveyTitleArea pageName="Members" />
      <SurveyContentContainer>
        <SurveySection labelText="Members">
          <SurveyElement
            questionNumber="6"
            labelText="Provide the breakdown of total members:"
          />
          <SurveyElement
            inputType="grid"
            styleName={"dataTable membersTable"}>
            <SurveyGridHeader>
              <SurveyElement
                labelText=""
                inputType={ElementType.LABEL}
                name=""
              />
              <SurveyElement
                labelText="End of most recent fiscal year "
                inputType={ElementType.LABEL}
              />
              <SurveyElement
                labelText="End of prior fiscal year "
                inputType={ElementType.LABEL}
              />
            </SurveyGridHeader>
            <SurveyGridBody>
              <SurveyGridRow>
                <SurveyElement
                  questionNumber="6.a"
                  labelText="Active Members"
                  inputType={ElementType.LABEL}
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  format={NumberFormat.INTEGER}
                  name="ActiveMembers"
                  placeholder="#"
                  pageName="Members"
                  allowNA allowUnknown
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  format={NumberFormat.INTEGER}
                  name="ActiveMembersLastYear"
                  placeholder="#"
                  pageName="Members"
                  allowNA allowUnknown
                />
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  questionNumber="6.b"
                  labelText="Inactive Members"
                  inputType={ElementType.LABEL}
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  format={NumberFormat.INTEGER}
                  name="InactiveMembers"
                  placeholder="#"
                  pageName="Members"
                  allowNA allowUnknown
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  format={NumberFormat.INTEGER}
                  name="InactiveMembersLastYear"
                  placeholder="#"
                  pageName="Members"
                  allowNA allowUnknown
                />
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  questionNumber="6.c"
                  labelText="Annuitants (Service, Disabled, Survivor)"
                  inputType={ElementType.LABEL}
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  format={NumberFormat.INTEGER}
                  name="Annuitants"
                  placeholder="#"
                  pageName="Members"
                  allowNA allowUnknown
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  format={NumberFormat.INTEGER}
                  name="AnnuitantsLastYear"
                  placeholder="#"
                  pageName="Members"
                  allowNA allowUnknown
                />
              </SurveyGridRow>
            </SurveyGridBody>
          </SurveyElement>
          <SurveyElement
            questionNumber="7"
            labelText="What were your volumes for: "
          />
          <SurveyElement
            questionNumber="7.a"
            labelText="Service retirement inceptions?"
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            name="MembershipServiceInceptionsVol"
            subQuestion
            placeholder="#, n/a, unknown"
            allowNA allowUnknown
          />
          <SurveyElement
            questionNumber="7.b"
            labelText="Inceptions to survivors, partners, ex-partners or dependents? "
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            name="MembershipSurvivorsInceptionsVol"
            subQuestion
            placeholder="#, n/a, unknown"
            allowNA allowUnknown
          />
          <SurveyElement
            questionNumber="7.c"
            labelText="Disability retirement inceptions? "
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            name="MembershipDisabilityInceptionsVol"
            subQuestion
            placeholder="#, n/a, unknown"
            allowNA allowUnknown
          />
          <SurveyElement
            questionNumber="7.d"
            labelText="Deaths of active, inactive members and annuitants? "
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            name="MembershipDeathVol"
            subQuestion
            placeholder="#, n/a, unknown"
            allowNA allowUnknown
          />
          <SurveyElement
            questionNumber="7.e"
            labelText="New active members?"
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            name="NewActivesExcludeRehires"
            subQuestion
            placeholder="#, n/a, unknown"
            allowNA allowUnknown
          />
          <SurveyElement
            questionNumber="7.f"
            labelText="Active members exiting employment?"
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            name="ActiveToInactive"
            subQuestion
            note="Exclude service and disability retirements"
            placeholder="#, n/a, unknown"
            allowNA allowUnknown
          />
          <SurveyElement
            questionNumber="7.g"
            labelText="Withdrawals, refunds? "
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            name="MembershipRefundsVol"
            subQuestion
            placeholder="#, n/a, unknown"
            allowNA allowUnknown
          />
          <SurveyElement
            questionNumber="7.h"
            labelText="Transfers-out?"
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            name="MembershipTransfersOutVol"
            subQuestion
            placeholder="#, n/a, unknown"
            allowNA allowUnknown
          />
          <SurveyElement
            questionNumber="8"
            labelText="Can you provide the following information about your active members: "
          />
          <SurveyElement
            questionNumber="8.a"
            labelText="Average age?"
            inputType={ElementType.NUMBER}
            format={NumberFormat.DECIMAL1}
            name="MembershipAverageAge"
            subQuestion
            placeholder="# years"
            allowUnknown
          />
          <SurveyElement
            questionNumber="8.b"
            labelText="Average tenure?"
            inputType={ElementType.NUMBER}
            format={NumberFormat.DECIMAL1}
            name="MembershipAverageTenure"
            subQuestion
            placeholder="# years"
            allowUnknown
          />
          <SurveyElement
            questionNumber="8.c"
            labelText="Average salary?"
            inputType={ElementType.NUMBER}
            format={NumberFormat.MONEY}
            name="MembershipAverageSalary"
            subQuestion
            placeholder={currencyPlaceHolder}
            allowUnknown
          />
        </SurveySection>
      </SurveyContentContainer>

    </SurveyPage>
  );
}